import { useState } from "react";
import { Button, Form, Container, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();

    // 🔹 Login propio con API
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_URL}/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await res.json();
            if (res.ok) {
                localStorage.setItem("token", data.token);
                alert("Inicio de sesión exitoso");
                window.location.href = "/dashboard"; // Redirigir tras login
            } else {
                alert(data.message);
            }
        } catch (error) {
            console.error("Error en el login:", error);
            alert("Error de conexión con el servidor.");
        }
    };

    // 🔹 Login con Google (Auth0)
    const handleGoogleLogin = () => {
        loginWithRedirect();
    };

    return (
        <Container className="d-flex justify-content-center align-items-center local-hire-design" style={{ minHeight: '100vh' }}>
            <Card className="p-4 shadow-lg border-0 rounded-lg" style={{ maxWidth: '400px', width: '100%' }}>
                <Card.Body>
                    {isAuthenticated ? (
                        <div className="text-center">
                            <h3 className="text-primary">Bienvenido, {user.name}</h3>
                            <p>{user.email}</p>
                            <Button variant="danger" onClick={() => logout({ returnTo: window.location.origin })}>
                                Cerrar sesión
                            </Button>
                        </div>
                    ) : (
                        <>
                            <h2 className="text-center mb-4 text-primary fw-bold font-montserrat">Iniciar sesión</h2>

                            <Row className="mb-3">
                                <Col>
                                    <Button
                                        variant="outline-danger"
                                        className="w-100 mb-2 rounded-pill shadow-sm"
                                        onClick={handleGoogleLogin}
                                    >
                                        <i className="bi bi-google me-2"></i>
                                        Iniciar sesión con Google
                                    </Button>
                                </Col>
                            </Row>

                            <div className="text-center text-muted my-3">o usa tu correo</div>

                            <Form onSubmit={handleLogin}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label className="fw-medium">Correo electrónico</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Ingresa tu correo"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="rounded-pill shadow-sm"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label className="fw-medium">Contraseña</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Ingresa tu contraseña"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="rounded-pill shadow-sm"
                                        required
                                    />
                                </Form.Group>

                                <Button variant="primary" type="submit" className="w-100 rounded-pill shadow-sm">
                                    Iniciar sesión
                                </Button>
                            </Form>

                            <div className="text-center mt-3">
                                <small className="text-muted">
                                    ¿No tienes una cuenta? <Link to="/register" className="text-primary fw-bold">Regístrate</Link>
                                </small>
                            </div>
                        </>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Login;
